import React, { useEffect, useRef } from "react";
import { Collapse } from "antd";
import { useCanvas } from "../../context/canvasContext";
import './antSidebar.css';
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDocument } from "../../context/documentInfoContex";

const { Panel } = Collapse;

const FramesModal = ({ isFrameModalVisible, setIsFrameModalVisible, triggerButtonRef }) => {
    const { id } = useParams();
    const isMobile = window.screen.width < 768;
    const { canvasRef, createFrame } = useCanvas();
    const { setBoardData } = useDocument();
    const modalRef = useRef(null);

    const createFrameOption = (type) => {
        const frameOptions = {
            "A4": { width: 595, height: 842 }, // A4 in pixels
            "Letter": { width: 612, height: 792 }, // Letter size
            "16:9": { width: 960, height: 540 }, // 16:9 ratio
            "4:3": { width: 800, height: 600 }, // 4:3 ratio
            "1:1": { width: 600, height: 600 }, // Square
            "Custom": { width: 400, height: 300 }, // Default custom size
        };

        const frame = frameOptions[type] || frameOptions["Custom"];
        createFrame(id, {
            width: frame.width,
            height: frame.height,
            left: 100,
            top: 100,
            fill: '#fff',
            stroke: '#d8d8d8',
            strokeWidth: 2,
        });
        if (canvasRef?.current) {
            const canvasData = canvasRef.current.toJSON(["selectable", "id", "type"]);
            setBoardData(canvasData);
        } else {
            console.warn("canvasRef is not ready");
        }
        setIsFrameModalVisible(false);
    };

    useEffect(() => {
        if (isFrameModalVisible && triggerButtonRef?.current && modalRef?.current) {
            const buttonRect = triggerButtonRef.current.getBoundingClientRect();
            const modal = modalRef.current;
            const parentRect = triggerButtonRef.current.offsetParent.getBoundingClientRect();

            // Calculate position relative to the parent (toolbar)
            const offsetX = 10;
            const offsetY = isMobile ? 40 : 0;
            const newLeft = buttonRect.left - parentRect.left + buttonRect.width + offsetX;
            const newTop = isMobile
                ? buttonRect.top - parentRect.top + buttonRect.height + offsetY
                : buttonRect.top - parentRect.top;

            const modalWidth = isMobile ? 155 : 168;
            const viewportWidth = window.innerWidth;
            const adjustedLeft = Math.min(newLeft, viewportWidth - modalWidth - 10);

            modal.style.position = 'absolute';
            modal.style.left = `${adjustedLeft + 40}px`;
            modal.style.top = `${newTop}px`;
            modal.style.zIndex = '10';
        }
    }, [isFrameModalVisible, triggerButtonRef, isMobile]);

    if (!isFrameModalVisible) {
        return null;
    }

    const handleCollapseChange = (key) => {
        if (key.length === 0) {
            setIsFrameModalVisible(false);
        }
    };

    return (
        <div
            ref={modalRef}
            style={{
                width: isMobile ? '155px' : '168px',
                boxShadow: "rgb(101 92 92 / 50%) 0px 3px 8px",
                borderRadius: "5px",
                backgroundColor: '#fff',
            }}
        >
            <Collapse
                bordered={true}
                expandIconPosition="right"
                defaultActiveKey={['1']}
                onChange={handleCollapseChange}
                style={{ margin: 0, padding: 0 }}
            >
                <Panel
                    style={{ fontSize: isMobile ? '11px' : '13px', margin: 0 }}
                    header="Frames"
                    key="1"
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', cursor: 'pointer' }}>
                        {["A4", "Letter", "16:9", "4:3", "1:1", "Custom"].map((type) => (
                            <div
                                key={type}
                                onClick={() => createFrameOption(type)}
                                style={{
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '3px',
                                    textAlign: 'center',
                                    backgroundColor: '#f7f7f7',
                                }}
                            >
                                {type}
                            </div>
                        ))}
                    </div>
                </Panel>
            </Collapse>
        </div>
    );
};

export default FramesModal;
